// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__kR3ao","overlayWrapper":"Loader_overlayWrapper__fPZ_x"};